import { PageHeader, Spinner } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentList } from '~/features/StressAssessmentList';
import { StressAssessmentScheduleAlert } from '~/features/StressAssessmentScheduleAlert';
import { StressAssessmentScheduleNotificationBanner } from '~/features/StressAssessmentScheduleNotificationBanner';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <PageHeader variant='title' title='ストレスチェック' />
        <div className={styles.ScheduleAlertWrapper}>
          <Suspense fallback={<Spinner />}>
            <StressAssessmentScheduleAlert />
          </Suspense>
        </div>
        <Suspense fallback={<Spinner />}>
          <StressAssessmentList />
        </Suspense>
      </div>
      <div className={styles.BannerWrapper}>
        <Suspense fallback={null}>
          <StressAssessmentScheduleNotificationBanner />
        </Suspense>
      </div>
    </div>
  );
};
